<span
  [ngbTooltip]="pickupData?.length ? tooltipTemplate : null"
  triggers="mouseover:mouseleave"
  container="body"
  [autoClose]="true"
  [placement]="placement"
  tooltipClass="history--toolTip"
>
  <i *ngIf="forHistIcon && pickupData?.length" class="far fa-history color_cyan"></i>
  <ng-content *ngIf="!forHistIcon"></ng-content> <!-- This shows pickup date in the cell -->
</span>

<ng-template #tooltipTemplate>
  <div class="row-text-left">
    <div class="col-md-12">
      <label class="margin_bottom_1rem text-decoration_underline">Picked up Information</label>
    </div>
  </div>
  <div class="row text-start listInfo">
    <ul *ngFor="let pickupHist of pickupData; let i = index" class="col-12 pe-0 mt-1 mb-1">
      <li>
        <div class="col-12 p-0">
          <div class="row">
            <div class="col-md-7">
              <label>Date & Time:</label>
              <span> {{getFormattedPickupDate(pickupHist)}} </span>
            </div>
            <div class="col-md-5">
              <label>Qty Disp:</label>
              <span> {{getPickupQuantity(pickupHist) | number : '1.3-3' }}</span>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</ng-template>


